import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/speed-to-lead/")({
  beforeLoad: () => {
    throw redirect({ to: "/speed-to-lead/campaigns" });
  },
});
